import Api from "../../api.service";
import Swal from "sweetalert2";
const state = {
    breadcrumbs_items: [],
    isLoading: true,
    placeholder: "/media/placeholder/image-placeholder.jpg",
    //domainHost: "https://localhost:44319",
    domainHost: "https://cpan.imhere-co.com",
    citiesList: [],
    schedulesList: [],
    areasList: [],
    shopsList: [],
    mini: true,
    smsDto:{
        id:0,
        message:""
    }
};
const getters = {
    breadcrumbs_items(state) {
        return state.breadcrumbs_items;
    },
    isLoading(state) {
        return state.isLoading;
    },
    domainHost(state) {
        return state.domainHost;
    },
    citiesList(state) {
        return state.citiesList;
    },
    schedulesList(state) {
        return state.schedulesList;
    },
    areasList(state) {
        return state.areasList;
    },
    shopsList(state) {
        return state.shopsList;
    },
    placeholder(state) {
        return state.placeholder;
    },
    mini(state){
        return state.mini;
    },
    smsDto(state){
        return state.smsDto;
    }
};
const mutations = {
    SET_BREADCRUMBS_ARRAY(state, payload) {
        state.breadcrumbs_items = payload;
    },
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload;
    },
    GET_CITY_LIST(state, payload) {
        state.citiesList = payload;
    },
    GET_SCHEDULE_LIST(state, payload) {
        state.schedulesList = payload;
    },
    GET_AREA_LIST(state, payload) {
        state.areasList = payload;
    },
    GET_SHOP_LIST(state, payload) {
        state.shopsList = payload;
    },
    SET_MINI_DRAWER(state, payload){
        state.mini = payload;
    },
    SUCCESS_MSG(state)
    {
        Swal.fire({
            title: "تم الإرسال !",
            text: `تم إرسال رسالة للمشترك بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    }
};
const actions = {
    setBreadcrumbs(context, payload) {
        context.commit("SET_BREADCRUMBS_ARRAY", payload);
    },
    setLoading(context, payload) {
        context.commit("SET_IS_LOADING", payload);
    },
    async fetchCitiesList(context) {
        const { data } = await Api.query("/api/City/GetCities").then(
            data => data
        );
        context.commit("GET_CITY_LIST", data);
    },
    async fetchSchedulesList(context) {
        const { data } = await Api.query("/api/Schedule/SchedulesList").then(
            data => data
        );
        
        context.commit("GET_SCHEDULE_LIST", data);
    },
    async fetchAreasList(context) {
        const { data } = await Api.query("/api/Area/AreasList").then(
            data => data
        );
        
        context.commit("GET_AREA_LIST", data);
    },
    async fetchShopsList(context) {
        const { data } = await Api.query("/api/Shop/ShopsList").then(
            data => data
        );
        context.commit("GET_SHOP_LIST", data);
    },
    setMiniDrawer(context, payload) {
        context.commit('SET_MINI_DRAWER', payload)
    },
    async sendShopSMS(context, payload) {
        const { data } = await Api.post("/api/Shop/SendShopSMS", payload)
            .then((data) => data);
        if (typeof data === 'string') {
            context.commit("ERROR_MESSAGE", data);
        } else {
            context.commit("SUCCESS_MSG");
            context.commit("APPEND_RECORD", payload);
        }
    },
    async sendUserSMS(context, payload) {
        const { data } = await Api.post("/api/UserInfo/SendUserSMS", payload)
            .then((data) => data);
        if (typeof data === 'string') {
            context.commit("ERROR_MESSAGE", data);
        } else {
            context.commit("SUCCESS_MSG");
        }
    }
};

const appStore = { state, getters, mutations, actions };

export default appStore;
